{
  "fr": {
    "modelPicker": {
      "hangarTitle": "Ajouter des vaisseaux à votre hangar",
      "compareTitle": "Sélectionner des vaisseaux à comparer",
      "cargoGridsTitle": "Sélectionner des vaisseaux pour la grille de cargaison",
      "tradeRoutesTitle": "Choisir un vaisseau pour les routes commerciales",
      "wishlistTitle": "Ajouter des vaisseaux à votre liste de souhaits",
      "labels": {
        "search": "Rechercher par nom ou constructeur",
        "hangarOnly": "Uniquement mes vaisseaux",
        "containerFit": "Cargaison à transporter",
        "results": "%{count} vaisseaux",
        "selected": "%{count} sélectionnés"
      },
      "actions": {
        "resetFilters": "Réinitialiser les filtres",
        "moreFilters": "Plus de filtres",
        "clearSelection": "Effacer la sélection",
        "increase": "Ajouter un autre %{name}",
        "decrease": "Retirer un %{name}"
      },
      "badges": {
        "inHangar": "Dans le hangar",
        "onWishlist": "Dans la liste de souhaits",
        "comparing": "En comparaison",
        "onCargoGrid": "Sur la grille"
      }
    }
  }
}
